import PicklistMetadata from "../PicklistMetadata";

class AccountUserPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "AccountUser";
        this.bounded = true;
        this.enterpriseComponent = "AccountUser";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.useRealm = false;
        this.sortSpecification = [
            {
                "SortAttribute": "Name",
                "Direction": "ASC"
            }
        ];
        this.static = false;
        this.typeField = "Name";
        this.typeValue = "USID";
        this.typeValue2 = null;
        this.visibilityType = null;
        this.allowNoSelection = false;
        this.allowNoSelectionValue = null;
        this.allowNoSelectionDisplayValue = null;
    }
}

export default AccountUserPicklistMetadata;
